import { Container, VStack, Heading, Text, Button, Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

/**
 * Thank You page shown after completing the questionnaire
 * when chat is not enabled
 */
export default function ThankYouPage() {
  const navigate = useNavigate();

  return (
    <Container maxW="container.md" py={16}>
      <VStack spacing={6} align="center" textAlign="center">
        <Box fontSize="6xl">✅</Box>
        
        <Heading size="xl">
          Thank You!
        </Heading>
        
        <Text fontSize="lg" color="gray.600" maxW="md">
          Your responses have been saved. We appreciate you taking the time to complete this assessment.
        </Text>
        
        <Text color="gray.500">
          Your insights will help us better understand writing challenges and improve our support.
        </Text>
        
        <Button
          colorScheme="blue"
          size="lg"
          mt={4}
          onClick={() => navigate('/')}
        >
          Return to Home
        </Button>
      </VStack>
    </Container>
  );
}
